<template>
  <div
    id="mainbox"
    style="
      padding: 34px;
      background-color: #f1f4fa;
      height: calc(100vh - 51px);
      box-sizing: border-box;
      overflow: scroll;
    "
  >
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      "
    >
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        style="margin-bottom: 39px"
      >
        <el-breadcrumb-item
          v-for="(item, key) in breadcrumb"
          :key="key"
          :to="{ name: item.path }"
        >
          {{ item.name }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div
      style="
        background-color: #fff;
        overflow: hidden;
        padding: 0 36px;
        text-align: left;
      "
    >
      <div style="text-align: left; margin: 18px 0">查询</div>
      <div
        class="formBox"
        style="
          background: #ffffff;
          border: 2px solid #dcdfe6;
          display: inline-block;
        "
      >
        <el-form
          :inline="true"
          style="text-align: left"
          :model="formInline"
          class="demo-form-inline"
        >
          <el-form-item label="品牌名称">
            <el-select
              style="width: 200px"
              v-model="formInline.brand_name"
              placeholder="请选择品牌名称"
            >
              <el-option
                v-for="brand in brandList"
                :key="brand.id"
                :label="brand.name"
                :value="brand.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否被忽略">
            <el-select
              style="width: 200px"
              v-model="formInline.isignored"
              placeholder="请选择是否被忽略"
            >
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                getList();
              "
              >查询</el-button
            >
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column prop="brand_id" label="品牌 ID"> </el-table-column>
          <el-table-column prop="brand_name" label="品牌名称">
          </el-table-column>
          <el-table-column prop="agent_id" label="站点 ID"> </el-table-column>
          <el-table-column prop="agent_name" label="站点名"> </el-table-column>
          <el-table-column prop="isignored" label="是否被忽略">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isignored"
                :active-value="1"
                :inactive-value="0"
                @change="toggleIgnore(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin: 20px 0"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AgentList",
  data() {
    return {
      breadcrumb: [{ name: "站点列表" }],
      tableData: [],
      formInline: { brand_name: "", isignored: -1 },
      currentPage: 1,
      pageSize: 20,
      total: 0,
      brandList: [],
    };
  },
  methods: {
    handleSizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getList();
    },
    getList() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$axios
        .get("/api/agent/list", {
          params: {
            page: this.currentPage,
            page_size: this.pageSize,
            brand_name: this.formInline.brand_name,
            isignored: this.formInline.isignored,
          },
        })
        .then((response) => {
          loading.close();
          this.tableData = response.data.data.items;
          this.total = response.data.data.total;
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
          loading.close();
        });
    },
    reset() {
      this.currentPage = 1;
      this.formInline = { brand_name: "", isignored: "" };
      this.getList();
    },
    getBrandList() {
      this.$axios
        .get("/api/brand/list")
        .then((response) => {
          this.brandList = response.data.items;
          if (this.brandList.length > 0) {
            this.formInline.brand_name = this.brandList[0].name;
            this.getList();
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
        });
    },
    toggleIgnore(row) {
      const url =
        row.isignored === 1
          ? "/api/agentignore/create"
          : `/api/agentignore/delete/${row.brand_id}/${row.agent_id}`;
      const method = row.isignored === 1 ? "post" : "delete";
      const requestData =
        row.isignored === 1
          ? {
              brand_id: row.brand_id,
              agent_id: row.agent_id,
            }
          : {};
      this.$axios({
        method: method,
        url: url,
        data: requestData,
      })
        .then(() => {
          this.$message.success("操作成功");
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            this.$message.error(err.response.data.message);
          }
        });
    },
  },
  mounted() {
    this.getBrandList();
  },
};
</script>

<style>
body {
  margin: 0;
}
</style>
